// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-pGlzQY","openAppButton":"openAppButton-tFBcc5"};